import script from "./SuporteEquipamentos.vue?vue&type=script&setup=true&lang=js"
export * from "./SuporteEquipamentos.vue?vue&type=script&setup=true&lang=js"

import "./SuporteEquipamentos.vue?vue&type=style&index=0&id=0312a7e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0312a7e7"]])

export default __exports__